import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ListingImage from '../listing-image/ListingImage';

export default class Carousel extends Component {
  constructor (props) {
    super(props);

    this.next = this.next.bind(this);
    this.prev = this.prev.bind(this);

    this.renderImage = this.renderImage.bind(this);
    this.onPicLoad = this.onPicLoad.bind(this);
    this.handleCarouselEventAnalytics = this.handleCarouselEventAnalytics.bind(this);
    this.state = {
      activeIndex: 0,
      isSliding: false,
      clickedOnce: false
    };
  }

  onPicLoad () {
    this.setState({ isSliding: false });
  }

  handleCarouselEventAnalytics () {
    if (!this.state.clickedOnce && this.props.source && analyticsIntegrations.photoCarouselInteraction) {
      analyticsIntegrations.photoCarouselInteraction(this.props.listing._id, this.props.source);
    }
  }

  next (e) {
    e.preventDefault();

    const { activeIndex } = this.state;
    const { listing: { images = [] } } = this.props;

    const nextImage = activeIndex + 1;
    const nextActive = images.length > nextImage ? nextImage : 0;
    this.handleCarouselEventAnalytics();
    this.setState({
      activeIndex: nextActive,
      isSliding: true,
      clickedOnce: true
    });
  }

  prev (e) {
    e.preventDefault();

    const { activeIndex } = this.state;
    const { listing: { images = [] } } = this.props;

    const prevImage = activeIndex - 1;
    const lastImage = images.length - 1;
    const nextActive = 0 > prevImage ? lastImage : prevImage;
    this.handleCarouselEventAnalytics();
    this.setState({
      activeIndex: nextActive,
      isSliding: true,
      clickedOnce: true
    });
  }

  renderImage (image, i) {
    const { listing: { images = [] }, isMap } = this.props;
    const { activeIndex, isSliding } = this.state;
    const isActive = i === activeIndex;
    const isPrev = images.indexOf(images[images.length - 1]) === i;
    const isNext = (i === activeIndex + 1);

    // Load visible image
    if (isActive) {
      return (
        <div key={ `image-${ i + 1 }` }>
          <div className="loading-container" style={ { display: isSliding ? 'block' : 'none' } }>
            <span className="spinner search-load"></span>
          </div>
          <div className="carousel-item" style={ { display: isSliding ? 'none': 'block' } }>
            <ListingImage
              imgId={ image.external_id }
              ratio={ 1.69 }
              widths={ [256, 512] }
              defaultWidth={ 169 }
              defaultHeight={ 100 }
              alt={ 'peerspace' }
              sizes="50vw"
              style={ `cld-responsive cld-hidpi img-responsive lazyload` }
              onPicLoad={ this.onPicLoad }
            />
          </div>
        </div>
      );
    }

    // Load images before and after visible image
    if ((isPrev || isNext) && !isMap) {
      return (
        <div className="carousel-item" key={ `image-${ i + 1 }` } style={ { display: 'none' } }>
          <ListingImage
            imgId={ image.external_id }
            ratio={ 1.69 }
            widths={ [256, 512] }
            defaultWidth={ 169 }
            defaultHeight={ 100 }
            alt={ 'peerspace' }
            sizes="50vw"
            style={ `cld-responsive cld-hidpi img-responsive lazyload` }
            onPicLoad={ this.onPicLoad }
          />
        </div>
      );
    }

    return (
      <div className="carousel-item" key={ `image-${ i + 1 }` } />
    );
  }

  render () {
    const { listing: { images = [] }, isMap } = this.props;
    const showControls = images.length > 1 && !isMap;

    return (
      <div className="carousel">
        { showControls &&
            <div className="carousel-control carousel-control-prev scroll-image-left" onClick={ this.prev }>
              <i className="icon-image-arrows"></i>
            </div>
        }

        { images.map(this.renderImage) }

        { showControls &&
            <div className="carousel-control carousel-control-next scroll-image-right" onClick={ this.next }>
              <i className="icon-image-arrows"></i>
            </div>
        }
      </div>
    )
  }
}

Carousel.propTypes = {
  images: PropTypes.array,
  isMap: PropTypes.bool,
  listing: PropTypes.object,
  source: PropTypes.string
};
